/**
 * This file is part of the box.co.il project.

 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */
// todo@alexbuturlakin: this file was created from inlined code in domain/info.php template. Looks like it need some refactoring (rm -rf ??).
;(function($) {
  // hm... may be need to remove this
  if (typeof(ctype_print) != "function") {
    function ctype_print(str) {
      var allowed = 'abcdefghijklmnopqrstuvwxyz0123456789*!@#$%^?:&*~=_.,<>{}"|-;`+()[]/\\\' ';
      allowed = allowed.split('');
      var chars = str.split('');
      var status = true;
      for (var i = 0; i < chars.length; i++) {
        var singleChar = chars[i].toLowerCase();
        if (allowed.indexOf(singleChar) === -1) {
          status = false;
          break;
        }
      }
      return status;
    }
  }

  $(document).ready(function() {
    var isNotifiedAboutPremium = false;

    // select domain purchase period
    $('input[name=domainPeriod]').change(function () {
      var el          = $(this),
          validation  = el.closest('label').siblings('.validation'),
          success     = validation.find('.ok'),
          cardDetails = $('#creditCardDetails');

      // show success message
      if(success.hasClass('hidden')) {
        // hide error
        validation.find('.error').addClass('hidden');

        // show success message
        success.removeClass('hidden');
      }

      // change message
      success.find('span>span').html(' ' + el.data('date'));

      // update price info
      $.updateTotalPrice();

      // clean card form fields
      cardDetails.resetForm();
      $('#cpn-error').addClass('hidden');

      isReadyToBuy();
    });

    // change label by selected client type
    $('#ownerModal').find('[name="clientType"]').on('change', function() {
      var el        = $(this),
          val       = el.val(),
          container = el.closest('.modal-body'),
          label     = container.find('[for="ownerFullName"]'),
          input     = container.find('[name="ownerFullName"]');

      // set label and placeholder
      label.find('span').html(input.data('label-{0}'.format(val)));
      input.attr('placeholder', input.data('placeholder-{0}'.format(val)));

      // Change validation rules for owner name
      var nameValidation = 'clientTypeCompany' === el.attr('id')
        ? window.validationRules.purchaseDomainRulesOwnerName.company
        : window.validationRules.purchaseDomainRulesOwnerName.user
      ;

      el.closest('form').validatorChangeFieldRules('ownerFullName', nameValidation.rules, nameValidation.messages);

      // clear input
      input.val('');

      container.find('.form-group-{0}'.format(val)).removeClass('hidden');
      container.find('.form-group-{0}'.format('company' === val ? 'private' : 'company')).addClass('hidden');
    });

    $('#ownerCompanyId').on('default-data-populated', function() {
      if ($('input[name=clientType]:checked').val() == 'company') {
        $(this).closest('.form-group-company').removeClass('hidden');
      }
    });

    $('input[name=dnsType]').change(function () {
      var val = $('input[name=dnsType]:checked').val();
      if (val == 'adv') {
        $('input.names').each(function () {
          $(this).val($(this).attr('data-value'));
        });

        $('#dnsAdv').show();
      }

      if ('cloud' == val) {
        $('#dnsAdv').hide();

        $('input.names').each(function () {
          $(this).val($(this).attr('data-value-cloud'));
        });
      }

      if (val == 'default') {
        $('#dnsAdv').hide();
        $('input.names').each(function () {
          $(this).val($(this).attr('data-value'));
        });
      }
    });

    $('#creditCardDetails .cvvhelp').hover(function () {
      $(this).find('img').show();
    }, function () {
      $(this).find('img').hide();
    });

    $('#domainCheckout').click(function () {
      var el   = $(this),
          next = el.attr('data-next');
      if (isReadyToBuy()) {
        if('email-account' === next) {
          var eaBlock = $('#domain-purchase-email-account');
          eaBlock.removeClass('hidden');
          $(document).scrollTop(eaBlock.offset().top-100);
          // $([document.documentElement, document.body]).animate({
          //     scrollTop: $('.form-group.isReady').offset().top+550
          // }, 2000);
        }

        if('card-data' === next) {
          $('#creditCardDetails').removeClass('hidden');

          $('.show-tooltip').addTooltip();

          $.updateTotalPrice();
          $(document).scrollTop($('#domainCheckout').offset().top+100);

          // $([document.documentElement, document.body]).animate({
          //     scrollTop: $(".form-group.isReady").offset().top+600
          // }, 2000);

        }
      }
    });

    // step 2
    $('#domain-purchase-email-account-accept').click(function() {
      $('#domain-purchase-cashback').removeClass('hidden');
      $(document).scrollTop($('#domain-purchase-cashback').offset().top);
    });

    $('#domain-purchase-owner-email-verify-accept').click(function() {
      var valid = true;

      if (!$('#ownerEmailVerificationCode').val() || $('#ownerEmailVerificationCode').val().length != 8) {
        $('#domain-purchase-owner-email-verify-errors').html($.translate('Email verification code is invalid')).removeClass('hidden');
        valid = false;
      }

      if (isReadyToBuy() && valid) {
        $('#domain-purchase-owner-email-verify-errors').addClass('hidden');
        $('#creditCardDetails').removeClass('hidden');
        $.updateTotalPrice();
        $(document).scrollTop($('#creditCardDetails').offset().top);
        // $([document.documentElement, document.body]).animate({
        //     scrollTop: $('.form-group.isReady').offset().top+300
        // }, 1000);
        // notify user about premium domain

        $('.show-tooltip').addTooltip();


        if (true === Storage.getData('isPremiumDomain') && false == isNotifiedAboutPremium) {
          $.showSuccess(
            $.translate('Premium Domain Purchasing'),
            Storage.getData('premiumMessage'),
            false,
            true
          );

          isNotifiedAboutPremium = true;
        }
      }
    });

    $('#domain-purchase-email-accounts-decline').click(function() {
      $('#domain-purchase-email-account input[type=checkbox]').prop('checked', false);
      $('#domain-purchase-email-account').addClass('hidden');

      $('#domain-purchase-cashback').removeClass('hidden');
    });

    $('#domain-purchase-promo-accept').click(function() {
      $('.domainCashback').val('true')
      emailVerify(true)
    });

    $('#domain-purchase-promo-decline').click(function() {
      $('.domainCashback').val('false')
      $('#domain-purchase-cashback').addClass('hidden')
      emailVerify(false)
    });

    function emailVerify(scroll){
      if (isReadyToBuy()) {
        if ($('#domain-purchase-owner-email-verify').length) {
          $('#domain-purchase-owner-email-verify').removeClass('hidden');
          $('#domain-purchase-owner-email-verify-send-email span').text(' ' + $('#ownerEmail').val());

          if(scroll){
            $(document).scrollTop($('#domain-purchase-owner-email-verify').offset().top - 100);
          }
        } else {
          $('#creditCardDetails').removeClass('hidden');
          $.updateTotalPrice();

          if(scroll){
            $(document).scrollTop($('#creditCardDetails').offset().top - 100);
          }

          $('.show-tooltip').addTooltip();

          if (true === Storage.getData('isPremiumDomain') && false == isNotifiedAboutPremium) {
            $.showSuccess(
              $.translate('Premium Domain Purchasing'),
              Storage.getData('premiumMessage'),
              false,
              true
            );

            isNotifiedAboutPremium = true;
          }
        }
      }
    }

    $('#domain-purchase-owner-email-verify-send-email,#form-domain-purchase-owner-email-verify-resend').click(function (e) {
      e.preventDefault();
      $('#domain-purchase-owner-email-verify-send-email').button('loading');
      $('#form-domain-purchase-owner-email-verify-resend').button('loading');

      $.ajax({
        url: '/domain-email-verify/purchase',
        type: 'POST',
        data: {
          'email': $('#ownerEmail').val()
        },
        success: function (response) {
          if (0 == response.status) {
            $('#domain-purchase-owner-email-verify-errors').html(nl2br(response.msg, true)).removeClass('hidden');
            $('#domain-purchase-owner-email-verify-send-email').button('reset');
            $('#form-domain-purchase-owner-email-verify-resend').button('reset');
          }

          if (1 == response.status) {
            $('.domain-purchase-owner-email-verify-step-1').addClass('hidden');
            $('.domain-purchase-owner-email-verify-step-2').removeClass('hidden');
            $('#domain-purchase-owner-email-verify-send-email').button('reset');
            $('#form-domain-purchase-owner-email-verify-resend').button('reset');
          }
        },
        error: function (xhr) {
          if (403 === xhr.status) {
            window.location.href = '/user/login';
          }

          $('#domain-purchase-owner-email-verify-errors').html(xhr.responseJSON.error).removeClass('hidden');
        }
      });
    });

    $('#domain-purchase-email-account').on('click', 'input[type=checkbox]', function() {
      var ec = $('#domain-purchase-email-account-errors');

      ec.addClass('hidden');
    });

    $('#domain-purchase-email-account .form-group > span').click(function () {
      $('#domain-purchase-email-account-text').focus();
    });

    $('#domain-purchase-email-account-add').click(function() {
      var el      = $(this),
          input   = el.siblings('input'),
          value   = input.val(),
          proto   = el.attr('data-prototype'),
          eDomain = el.attr('data-email-domain'),
          cbBoxes = $('#domain-purchase-email-account input[type=checkbox]'),
          erCont  = $('#domain-purchase-email-account-errors'),
          cbCount = cbBoxes.length;

      var validator    = $('#domain-purchase-form').data('validator'),
          emailAccount = value + eDomain,
          isValid      = validator._hooks.valid_email({'value': emailAccount});

      erCont.addClass('hidden');

      // todo@alexbuturlakin: need to refactor
      if(value && value.length > 0 && isValid) {
        if(isValid) {
          if($('#domain-purchase-email-account input[value="{0}"][type="checkbox"]'.format(emailAccount)).length > 0) {
            erCont
                .html($.translate('Email account with the same name already added'))
                .removeClass('hidden');
          } else {
            var cbNew = $(proto.format(cbCount, cbCount, value));

            cbBoxes.last().parent().after(cbNew);

            cbNew = $('#domain-purchase-email-account-{0}'.format(cbCount));

            input.val('');
            cbNew.val(emailAccount);

            if(9 === cbBoxes.length) {
              el.parent().remove();
            }
          }
        }
      } else {
        erCont
            .html($.translate('Only English letters (a-z), numbers, periods, @<br><span>Example: Israel123@gmail.com</span>'))
            .removeClass('hidden');
      }
    });
  });

  /**
   * Update total price
   */
  $.updateTotalPrice = function() {
    var title  = $('#creditCardDetails').find('.UISection > span'),
        period = parseInt($('input[name=domainPeriod]:checked').val()),
        total  = 0;

    // update total price
    for (var i = 1; i < period + 1; i++) {
      var yearPrice = title.attr('data-price-{0}'.format(i));

      if (undefined !== yearPrice) {
        total += parseFloat(yearPrice);
      }
    }
    perYear = total / period;
	  totalPerYear = Number(perYear).toFixed(2);
    // update total price
    title.find('span').html(Number(total).toFixed(2));
    $("#PriceperYear").html(totalPerYear);
  };

})(jQuery);
